import { render, staticRenderFns } from "./ServicePayment.vue?vue&type=template&id=8186d4e0&"
import script from "./ServicePayment.vue?vue&type=script&lang=js&"
export * from "./ServicePayment.vue?vue&type=script&lang=js&"
import style0 from "./ServicePayment.vue?vue&type=style&index=0&id=8186d4e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports